import React, { Fragment } from 'react';
import { Field } from 'formik';
import LanguageForm from './LanguageForm';

const LanguageRow = ({ language, onRemove, onChange, ...props }) => {

  const radioName = `${language.name}.${language.id}`;

  return (
    <div className="row">
      <span>{language.name}</span>
      <div className="level">
        <label>
          <input
            type="radio"
            name={radioName}
            value="1"
            checked={language.proficiencyLevel == "1"}
            onChange={(e) => onChange(language.id, e.target.value)} />
          <span>1</span>
        </label>
        <label>
          <input
            type="radio"
            name={radioName}
            value="2"
            checked={language.proficiencyLevel == "2"}
            onChange={(e) => onChange(language.id, e.target.value)} />
          <span>2</span>
        </label>
        <label>
          <input
            type="radio"
            name={radioName}
            value="3"
            checked={language.proficiencyLevel == "3"}
            onChange={(e) => onChange(language.id, e.target.value)} />
          <span>3</span>
        </label>
      </div>
      <a className="icon-remove" onClick={() => onRemove(language.id)} title="remove">&#xe912;</a>
    </div>
  );
}

export const UserLanguagesField = ({ name, onChange, ...props }) => {
  return (
    <Field
      name={name}
      render={({ field, form: { setFieldValue } }) => (
        <Fragment>
          <UserLanguages
            {...props}
            id={field.name}
            onChange={value => setFieldValue(field.name, value)}
            value={field.value} />
        </Fragment>
      )}
    />
  );
}

export class UserLanguages extends React.Component {
  constructor(props) {
    super(props);

    this.handleRemove = this.handleRemove.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleAdd = this.handleAdd.bind(this);

    this.state = {
      values: props.value
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ values: nextProps.value });
  }

  handleAdd(language) {
    let original = this.state.values;
    let idx = original.findIndex(function (element) { return element.id === language.id });
    if (idx === -1) {
      original.push(language);
      this.setState({ values: original }, this.props.onChange(original));
    }
  }

  handleRemove(id) {
    let original = this.state.values;
    let idx = original.findIndex(function (element) { return element.id === id });
    if (idx > -1) {
      original.splice(idx, 1);
      this.setState({ values: original }, this.props.onChange(original));
    }
  }

  handleUpdate(id, value) {
    let original = this.state.values;
    let idx = original.findIndex(function (element) { return element.id == id });
    if (idx > -1) {
      original[idx].proficiencyLevel = value;
      this.setState({ values: original }, this.props.onChange(original));
    }
  }

  render() {
    return (
      <Fragment>
        <div className="languages-container">
          {this.state.values && this.state.values.length > 0 &&
            this.state.values.map((language, index) => (
              <LanguageRow
                key={index}
                language={language}
                onChange={this.handleUpdate}
                onRemove={this.handleRemove} />
            ))}
        </div>
        <LanguageForm
          onCreate={this.handleAdd}
          selectedLanguages={this.state.values} />
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/users/UserLanguages.js